import { PAYMENT_TARIFF, PERSONALIZED_PLAN } from '../../types';
import { getParameterFromURL } from '../../utils/scripts';
import { createEmptyWebCatalogProduct, WebCatalogProduct, WebCatalogDigitalProduct, createEmptyWebCatalogDigitalProductList } from '../../utils/services/EveryDoggyAPITypes';
import { getQuestionAnswer } from '../../utils/scripts/getQuestionAnswer';
import { parseTariff, isDiscountTariff } from '../../utils/scripts/parseTariff';
import { isK9FunnelConfig } from '../../utils/scripts/k9Funnel';

export interface IDataState {
  paymentModal: {
    withSpecialOffer: boolean;
    product: IPaymentModalProduct;
    productName?: string;
    withFreeBonus?: boolean;
  };
  productOnInitScreen: {
    name: string;
    details: null | WebCatalogProduct;
  };
  paymentCardBrand: string;
  stripeErrorsCreared: boolean;

  // do we need this here? can take this value from url anywhere
  animateButton: boolean;
  moreAccentToPrice: boolean;
  emailSetting1: boolean;
  pdfOffer: string;
  insufficientFunds: boolean;
  gender: string;
  pricesMusclesV0: boolean;
  tariff: PAYMENT_TARIFF;
  /** Derived from `tariff` — true when the current tariff is a discount/special-offer variant. */
  isDiscount: boolean;
  showWeekPrice: boolean | string;
  noPaypal: boolean;
  age: string[];
  goal: string[];
  biting: string[];
  pottyTraining: string[];
  personalizedPlan: PERSONALIZED_PLAN;
  vetOnboarding: boolean;
  nutritionOnboarding: boolean;
  puppyBlues: boolean;
  lastDogTraining: boolean;
  name: string[];
  productList: WebCatalogDigitalProduct;
  issues: string[];
  dogTranslator?: string;
  k9Funnel: boolean;
}

export interface IPaymentModalProduct {
  name: null | string;
  details: null | (WebCatalogProduct & { oldPrice?: string });
}

const urlSearchParams = new URLSearchParams(window.location.search);
const sourceParameters = Object.fromEntries(urlSearchParams.entries());

const age = getQuestionAnswer(sourceParameters.age) ?? [];
const goal = getQuestionAnswer(sourceParameters.goal) ?? [];
const biting = getQuestionAnswer(sourceParameters.biting) ?? [];
const pottyTraining = getQuestionAnswer(sourceParameters.potty_training) ?? [];
const name = getQuestionAnswer(sourceParameters.name) ?? [];
const issuesRaw = getParameterFromURL('issues') ?? '';
const issues = issuesRaw
  .split(',')
  .map(item => decodeURIComponent(item).trim())
  .filter(item => item.length > 0);
const dogTranslator = getParameterFromURL('dogTranslator') || undefined;
const config = getParameterFromURL('config');

const tariff = parseTariff(getParameterFromURL('tariff'));

const LAST_DOG_TRAINING_CONFIG_TARIFFS: Record<string, string[]> = {
  customV2: [PAYMENT_TARIFF.V41, PAYMENT_TARIFF.V001, PAYMENT_TARIFF.V002, PAYMENT_TARIFF.V003],
  customV58: [PAYMENT_TARIFF.V41],
  customV61: [PAYMENT_TARIFF.V41],
  customV64: [PAYMENT_TARIFF.V41],
  customV65: [PAYMENT_TARIFF.V41],
  customV69: [PAYMENT_TARIFF.V41],
  customV70: [PAYMENT_TARIFF.V41],
  customV71: [PAYMENT_TARIFF.V41],
  customV72: [PAYMENT_TARIFF.V41],
  customV75: [PAYMENT_TARIFF.V47],
};

const isLastDogTraining = (config: string, tariff: string) => {
  return Boolean(LAST_DOG_TRAINING_CONFIG_TARIFFS[config]?.includes(tariff));
};

const state: IDataState = {
  paymentModal: {
    withSpecialOffer: false,
    product: {
      name: null,
      details: createEmptyWebCatalogProduct(),
    },
    withFreeBonus: false,
  },
  productOnInitScreen: {
    name: getParameterFromURL('productOnInitScreen') || 'verv_INTRO',
    details: null,
  },
  paymentCardBrand: '',
  stripeErrorsCreared: false,
  animateButton: getParameterFromURL('animateButton') === 'false' ? false : true,
  moreAccentToPrice: getParameterFromURL('moreAccentToPrice') === 'true',
  pdfOffer: getParameterFromURL('pdfOffer'),
  insufficientFunds: false,
  //what?
  emailSetting1: getParameterFromURL('emailSetting') === '1',
  gender: getParameterFromURL('gender') || 'female',
  pricesMusclesV0: getParameterFromURL('pricesMusclesV0') === 'true',
  tariff,
  isDiscount: isDiscountTariff(tariff),
  showWeekPrice: getParameterFromURL('showWeekPrice') || false,
  noPaypal: getParameterFromURL('nopp') === 'true',
  personalizedPlan: getParameterFromURL('personalizedPlan') as PERSONALIZED_PLAN,
  vetOnboarding: config === 'customV55' || config === 'customV60',
  nutritionOnboarding: getParameterFromURL('config') === 'customV57' || getParameterFromURL('config') === 'customV66',
  puppyBlues: config === 'customV56' || config === 'customV62' || config === 'customV63' || config === 'customV67' || config === 'customV68',
  lastDogTraining: isLastDogTraining(config, tariff),
  age,
  goal,
  biting,
  pottyTraining,
  name,
  productList: createEmptyWebCatalogDigitalProductList(),
  issues,
  ...(dogTranslator !== undefined ? { dogTranslator } : {}),
  k9Funnel: isK9FunnelConfig(config),
};

export default state;
